/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Connection_ExpiredInputs */

const en_google_drive_connection_expired = /** @type {(inputs: Google_Drive_Connection_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive access has expired or was removed. Reconnect to continue.`)
};

const es_google_drive_connection_expired = /** @type {(inputs: Google_Drive_Connection_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El acceso a Google Drive ha caducado o se ha eliminado. Vuelve a conectar para continuar.`)
};

/**
* | output |
* | --- |
* | "Google Drive access has expired or was removed. Reconnect to continue." |
*
* @param {Google_Drive_Connection_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_connection_expired = /** @type {((inputs?: Google_Drive_Connection_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Connection_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_connection_expired(inputs)
	return en_google_drive_connection_expired(inputs)
});